export default function IconReturned({color = "white", size = 24}) {
    return (
        <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 3.5L10 3.5M10 3.5L8 1.5M10 3.5L8 5.5M8 8.5L2 8.5M2 8.5L4 10.5M2 8.5L4 6.5" stroke={color}
                  strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}
